import { Flex } from '@atlaskit/primitives';

import type { FunctionComponent } from 'react';
import LegalDisclaimer from './LegalDisclaimer/LegalDisclaimer';
import Headline from './Headline';
import PermissionsBullets from './PermissionsBullets';
import DocumentTitle from './DocumentTitle';

const PartnerCentral: FunctionComponent = () => {
  return (
    <>
      <DocumentTitle />
      <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
        <Flex alignItems="center" direction="column" gap="space.400">
          <Headline />
        </Flex>
        <PermissionsBullets />
        <LegalDisclaimer />
      </Flex>
    </>
  );
};

export default PartnerCentral;
